import { createFileRoute } from "@tanstack/react-router";
import { IdReviews } from "@/features/agreements/IdReviews";

export const Route = createFileRoute("/_app/agreements/id-reviews")({
  component: () => <IdReviews />,
});
